/* eslint-disable consistent-return */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
export const constructSearch = params => {
  let url = "";
  let hasParameter = false;
  for (const key in params) {
    const value = params[key];
    url += hasParameter ? "&" : "?";
    hasParameter = true;
    url += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }

  return url;
};

export const constructURL = (destination, params, hash) => {
  let url = destination + constructSearch(params);

  if (hash[0] !== "#") {
    throw new Error("Expected # at start of hash");
  }
  url += hash;

  return url;
};

/*
 * Convert a {@code window.location.search} string '?a=b&c=d' into an object {a: b, c: d}
 */
export const convertSearchToObject = string => {
  if (string.length === 0) {
    return {};
  }

  if (string[0] === "?") {
    string = string.substr(1);
  }
  if (string.indexOf("#") !== -1) {
    string = string.substr(0, string.indexOf("#"));
  }

  const result = {};
  [].each(string.split("&"), (i, value) => {
    value = value.split("=", 2);
    if (value.length === 2) {
      return (result[decodeURIComponent(value[0])] = decodeURIComponent(
        value[1]
      ));
    }
  });

  return result;
};
